import React, {Component, Fragment} from 'react';

import Header from '../../Include/Header/Header';

import OrdenPreCotizacion from './OrdenPreCotizacion';
import './OrdenPreCotizacion.css';

import {VerificarTokenAccess} from '../../../services/_Sis/VerificarTokenAccess/VerificarTokenAccess';
import {ReactLocalStorageService} from "../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import TokenNoValido from "../../../componets/Include/TokenNoValido/TokenNoValido";
import {GetTipoMenu} from "../../../settings/General/General";

class OrdenPreCotizacionIndex extends Component {
	
	state = {
		access: false
	};
	
	constructor(props) {
		
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			access: null,
			params: props.params || {}
		};
		
		VerificarTokenAccess.Active().then((response) => {
			this.setState({
				access: 1
			});
		}).catch((error) => {
			this.setState({
				access: 0
			});
		});
	}
	
	render() {
		return (
			<div className='OrdenPreCotizacionIndex'>
				
				<Header/>
				
				<div className={`Container ${GetTipoMenu()}`}>
					
					{this.state.access === 1 ? (
						
						<Fragment>
							
							<OrdenPreCotizacion params={this.state.params}/>
							
							{/*<FooterVenta/>*/}
						
						</Fragment>
					
					) : ''}
					
					{this.state.access === 0 ? (
						
						<Fragment>
							
							<TokenNoValido/>
						
						</Fragment>
					
					) : ''}
				
				</div>
			
			</div>
		);
	}
}

export class OrdenPreCotizacionIndex1 extends Component {
	render() {
		return (
			<Fragment>
				<OrdenPreCotizacionIndex params={this.props.match.params}/>
			</Fragment>
		);
	}
}

export class OrdenPreCotizacionIndex2 extends Component {
	render() {
		return (
			<Fragment>
				<OrdenPreCotizacionIndex params={this.props.match.params}/>
			</Fragment>
		);
	}
}

export class OrdenPreCotizacionIndex3 extends Component {
	render() {
		return (
			<Fragment>
				<OrdenPreCotizacionIndex params={this.props.match.params}/>
			</Fragment>
		);
	}
}
